<template>
  <div :id="`duHolder_${id}`" />
</template>
<script>
import 'babel-polyfill'
import 'es6-promise/auto'
import { mapState } from 'vuex'
import { toServiceDomain } from '@/api/serviceDomain'

function handleOnChange (e) {
  const text = e.options[e.selectedIndex].text
  // console.log(e.options)
  // console.log(text)
}
export default {
  name: 'DEXT5UploadFor',
  props: {
    single: { type: Boolean, default: false, required: false },
    category: { type: Boolean, default: false, required: false },
    id: { type: String, default: '', required: false },
    width: { type: String, default: '100%', required: false },
    height: { type: String, default: '200px', required: false },
    fileInfo: { type: Array, required: false },
    categoryInfo: { type: Array, required: false },
    isDebug: { type: Boolean, default: false }
  },
  data () {
    return {
      index: 0,
      makeDext: false,
      options: {},
      uploadingYn: 'N'
    }
  },
  watch: {
    fileInfo: function () {
      console.log('파일인포 변경=', JSON.stringify(this.fileInfo))
    }
  },
  destroyed () {
    if (this.isDebug) {
      console.log('destroyed => ' + this.options.id)
      console.log('DEXT5UPLOAD.isLoadedUploadEx => ' + DEXT5UPLOAD.isLoadedUploadEx(this.options.id))
      console.log('DEXT5UPLOAD.GetUploadByName => ' + DEXT5UPLOAD.GetUploadByName(this.options.id))
    }
    if (DEXT5UPLOAD.GetUploadByName(this.options.id) !== null) {
      DEXT5UPLOAD.Destroy(this.options.id)
    }
  },
  mounted () {
    if (this.isDebug) {
      console.log('dext5 mount')
    }

    let handlerUrl = ''
    const commonUrl = toServiceDomain(process.env.VUE_APP_COMMON_URL)
    if (commonUrl.startsWith('http')) {
      handlerUrl = commonUrl
    } else if (commonUrl.startsWith('//')) {
      handlerUrl = location.protocol + commonUrl
    }
    handlerUrl += '/commons/dext5/handler'

    const duOptions = {
      type: this.type,
      id: this.id,
      width: this.width || '100%',
      height: this.height || '500px',
      uploadHolder: 'duHolder_' + this.id,
      handlerUrl: handlerUrl,
      runtimes: 'html5',
      buttonBarEdit: 'add,download,remove,remove_all',
      event: {
        CreationComplete: this.onCreationComplete,
        TransferComplete: this.onTransferComplete,
        BeforeFileDownload: this.beforeFileDownload,
        FinishDownloaded: this.FinishDownloaded,
        AfterAddItemEndTime: this.AfterAddItemEndTime,
        AfterAddItem: this.AfterAddItem,
        BeforeDeleteItem: this.BeforeDeleteItem,
        BeforeAddItem: this.BeforeAddItem
      }
    }

    if (typeof (DEXT5UPLOAD) === 'undefined') {
      this.$loadScript('/dext5upload/js/dext5upload.js')
        .then(() => {
          this.MakeUpload(duOptions)
        })
        .catch(() => {
          console.log('load fail catch')
        })
    } else {
      this.MakeUpload(duOptions)
    }
    if (this.isDebug) {
      console.log('dext5 mount end')
    }
  },
  computed: mapState({
    serviceLang: (state) => state.auth.serviceLang
  }),
  methods: {
    suppressDextLicenseAlert () {
      if (window.__dextAlertPatched) return
      window.__dextAlertPatched = true

      const origAlert = window.alert
      window.__dextOrigAlert = origAlert
      const keywords = [
        '라이센스', 'License', '만료', '도메인',
        'product_key', 'license_key', 'expire', 'Expire'
      ]
      window.alert = function (msg) {
        const text = String(msg || '')
        if (keywords.some(k => text.includes(k))) {
          console.warn('[DEXT5 license alert suppressed]', text)
          return
        }
        return origAlert.apply(window, arguments)
      }

      // 라이센스 alert는 초기화 시점에만 발생 → 일정 시간 후 원본 복구
      setTimeout(() => this.restoreDextAlert(), 5000)
    },
    restoreDextAlert () {
      if (!window.__dextAlertPatched) return
      if (window.__dextOrigAlert) {
        window.alert = window.__dextOrigAlert // 원본 alert 복구
        delete window.__dextOrigAlert
      }
      window.__dextAlertPatched = false
    },
    ResetDext: function () {
      let handlerUrl = ''
      const commonUrl = toServiceDomain(process.env.VUE_APP_COMMON_URL)
      if (commonUrl.startsWith('http')) {
        handlerUrl = commonUrl
      } else if (commonUrl.startsWith('//')) {
        handlerUrl = location.protocol + commonUrl
      }
      handlerUrl += '/commons/dext5/handler'

      const duOptions = {
        type: this.type,
        id: this.id,
        width: this.width || '100%',
        height: this.height || '500px',
        uploadHolder: 'duHolder_' + this.id,
        handlerUrl: handlerUrl,
        runtimes: 'html5',
        buttonBarEdit: 'add,download,remove,remove_all',
        event: {
          CreationComplete: this.onCreationComplete,
          TransferComplete: this.onTransferComplete,
          BeforeFileDownload: this.beforeFileDownload,
          FinishDownloaded: this.FinishDownloaded,
          AfterAddItemEndTime: this.AfterAddItemEndTime,
          AfterAddItem: this.AfterAddItem,
          BeforeDeleteItem: this.BeforeDeleteItem,
          BeforeAddItem: this.BeforeAddItem,
          UploadBegin: this.UploadBegin,
          UploadCompleted: this.UploadCompleted
        }
      }

      if (typeof (DEXT5UPLOAD) === 'undefined') {
        this.$loadScript('/dext5upload/js/dext5upload.js')
          .then(() => {
            this.MakeUpload(duOptions)
          })
          .catch(() => {
            console.log('load fail catch')
          })
      } else {
        this.MakeUpload(duOptions)
      }
    },
    MakeUpload: function (options) {
      this.suppressDextLicenseAlert()
      if (DEXT5UPLOAD.GetUploadByName(options.id) !== null) {
        DEXT5UPLOAD.Destroy(options.id)
      }

      this.options = options

      switch (this.serviceLang) {
        case 'CHN':
        case 'ENG':
          DEXT5UPLOAD.config.Lang = 'en-us'
          break
        case 'KOR':
          DEXT5UPLOAD.config.Lang = 'ko-kr'
          break
        // case 'CHN':
        //   DEXT5UPLOAD.config.Lang = 'zh-cn'
        //   break
        case 'JPN':
          DEXT5UPLOAD.config.Lang = 'ja-jp'
          break
      }

      // console.log('makeUpload = ', JSON.stringify(this.options))
      DEXT5UPLOAD.config.Width = options.width
      DEXT5UPLOAD.config.Height = options.height
      DEXT5UPLOAD.config.Runtimes = options.runtimes
      DEXT5UPLOAD.config.Event = options.event
      DEXT5UPLOAD.config.UploadHolder = options.uploadHolder
      DEXT5UPLOAD.config.ButtonBarEdit = options.buttonBarEdit
      DEXT5UPLOAD.config.ListViewDragAndDrop = '1'
      DEXT5UPLOAD.config.ListViewDbclick = '1'
      if (this.category) {
        DEXT5UPLOAD.config.HeaderBarItem = '카테고리'
        DEXT5UPLOAD.config.HeaderBarItemWidth = '150'
        DEXT5UPLOAD.config.HeaderBarItemAlign = 'center'
      }

      if (options.handlerUrl !== '') {
        DEXT5UPLOAD.config.HandlerUrl = options.handlerUrl
      }

      this.dext5 = new Dext5Upload(options.id)
    },
    SendFile: function () {
      // DEXT5UPLOAD.AddUploadedFile('test', originName, path, size, customValue, this.Id)
      DEXT5UPLOAD.Transfer(this.id)
    },
    // DEXT5 Upload Event
    onCreationComplete: function (uploadId) {
      // console.log('onCreationComplete ' + uploadId)
      if (this.isDebug) {
        console.log('@@@@@@@@@@@@ created start ')
      }
      let $vm = this

      for (let i = 0; i < this.fileInfo.length; i++) {
        DEXT5UPLOAD.AddUploadedFile(this.index, this.fileInfo[i].originalName, '/', this.fileInfo[i].size, this.fileInfo[i].fileId, uploadId)
        DEXT5UPLOAD.SetUploadedFile(this.index, this.fileInfo[i].guid, this.fileInfo[i].originalName, '/', this.fileInfo[i].size, this.fileInfo[i].fileId, uploadId)
        this.index = this.index + 1
      }
      // console.log('onCreationComplete end')

      let fileListObj = DEXT5UPLOAD.GetUploadByName(uploadId).frameWin.document.getElementById('file_list')

      if (fileListObj) {
        if (this.category) {
          // console.log('this.category= ' + this.category)
          // console.log('this.categoryInf= ' + JSON.stringify(this.categoryInfo))
          let size = fileListObj.childNodes.length

          for (let i = 0; i < size; i++) {
            // console.log('@@@@@@@@ index = ', i)
            let customHeaderObj = fileListObj.childNodes[i].childNodes[0].childNodes[3].childNodes[0]
            customHeaderObj.style.textAlign = 'center'
            // customHeaderObj.innerHTML =
            let tempSelect = '<select style="height:15px;" id="' + $vm.fileInfo[i].guid + '">'

            // console.log('00000')
            // console.log('customHeaderObj.innerHTML = ' + tempSelect)
            for (let j = 0; j < this.categoryInfo.length; j++) {
              // console.log('iii= ', j)
              // console.log('this.categoryInfo[i] = ' + this.categoryInfo[j].value)
              // console.log('this.fileInfo[i].category = ' + this.fileInfo[i].category)
              //선택처리
              if (this.categoryInfo[j].value === this.fileInfo[i].category) {
                tempSelect += '<option value="' + this.categoryInfo[j].value + '" selected>' + this.categoryInfo[j].category + '</option>'
              } else {
                tempSelect += '<option value="' + this.categoryInfo[j].value + '" >' + this.categoryInfo[j].category + '</option>'
              }

              // console.log('customHeaderObj.innerHTML = ' + tempSelect)
            }

            tempSelect += '</select>'
            // console.log('444444= ', tempSelect)
            customHeaderObj.innerHTML = tempSelect
            let dextCategory = DEXT5UPLOAD.GetUploadByName(uploadId).frameWin.document.getElementById($vm.fileInfo[i].guid)
            dextCategory.onchange = function selectChange (e) {
              // console.log('select = ', dextCategory.value)
              // console.log('$vm.fileInfo= ' + JSON.stringify($vm.fileInfo))
              $vm.fileInfo[i].category = dextCategory.value
              // console.log('$vm.fileInfo[' + i + ']= ' + JSON.stringify($vm.fileInfo[i]))
              // $vm.$emit('update', $vm.fileInfo)
            }
            // console.log(dextCategory)
            // console.log('customHeaderObj.innerHTML', customHeaderObj.innerHTML)
          }
        }
      }
      this.makeDext = true
      if (this.isDebug) {
        console.log('@@@@@@@@@@@@ created end ')
      }
    },
    AfterAddItem: function (uploadID, strFileName, nFileSize, nAddItemIndex, objFile) {
      this.uploadingYn = 'Y'
      // console.log('AfterAddItem')
    },
    onTransferComplete: function (uploadId) {
      if (this.isDebug) {
        console.log('onTransferComplete ' + uploadId)
      }
      let jsonAll = DEXT5UPLOAD.GetAllFileListForJson(uploadId)

      // console.log('jsonAll ' + JSON.stringify(jsonAll))
      let originalName = jsonAll.newFile.originalName
      let size = jsonAll.newFile.size
      let guid = jsonAll.newFile.guid
      let fileId = jsonAll.newFile.responseCustomValue
      let status = jsonAll.newFile.status
      let contentType = jsonAll.newFile.mimeType
      for (let i = 0; i < originalName.length; i++) {
        let dextCategory = DEXT5UPLOAD.GetUploadByName(uploadId).frameWin.document.getElementById(jsonAll.newFile.guid)
        this.fileInfo.push({
          guid: guid[i],
          originalName: originalName[i],
          size: size[i],
          fileId: fileId[i],
          status: status[i],
          contentType: contentType[i],
          category: '',
          new: true,
          newFlag: 'Y'
        })
        DEXT5UPLOAD.SetUploadedFile(this.index, guid[i], originalName[i], '/', size[i], fileId[i], uploadId)
        this.index = this.index + 1
      }

      let $vm = this

      let fileListObj = DEXT5UPLOAD.GetUploadByName(uploadId).frameWin.document.getElementById('file_list')

      if (fileListObj) {
        if (this.category) {
          // console.log('this.category= ' + this.category)
          // console.log('this.categoryInf= ' + JSON.stringify(this.categoryInfo))
          let size = fileListObj.childNodes.length

          for (let i = 0; i < size; i++) {
            // console.log('@@@@@@@@ index = ', i, fileListObj.childNodes[i].childNodes[0].childNodes[3].childNodes[0])
            let customHeaderObj = fileListObj.childNodes[i].childNodes[0].childNodes[3].childNodes[0]
            customHeaderObj.style.textAlign = 'center'
            // customHeaderObj.innerHTML =
            let tempSelect = '<select style="height:15px;" id="' + $vm.fileInfo[i].guid + '">'

            // console.log('00000')
            // console.log('customHeaderObj.innerHTML = ' + tempSelect)
            // console.log('this.fileInfo[i].category = ' + this.fileInfo[i].category)
            if (this.fileInfo[i].category === '') {
              // console.log('미선택')
              tempSelect += '<option value="" selected>선택</option>'
            }
            for (let j = 0; j < this.categoryInfo.length; j++) {
              // console.log('iii= ', j)
              // console.log('this.categoryInfo[i] = ' + this.categoryInfo[j].value)
              // console.log('this.fileInfo[i].category = ' + this.fileInfo[i].category)
              if (this.categoryInfo[j].value === this.fileInfo[i].category) {
                tempSelect += '<option value="' + this.categoryInfo[j].value + '" selected>' + this.categoryInfo[j].category + '</option>'
              } else {
                tempSelect += '<option value="' + this.categoryInfo[j].value + '" >' + this.categoryInfo[j].category + '</option>'
              }

              // console.log('customHeaderObj.innerHTML = ' + tempSelect)
            }

            tempSelect += '</select>'
            // console.log('444444= ', tempSelect)
            customHeaderObj.innerHTML = tempSelect
            let dextCategory = DEXT5UPLOAD.GetUploadByName(uploadId).frameWin.document.getElementById($vm.fileInfo[i].guid)
            dextCategory.onchange = function selectChange (e) {
              // console.log('select = ', dextCategory.value)
              // console.log('$vm.fileInfo= ' + JSON.stringify($vm.fileInfo))
              $vm.fileInfo[i].category = dextCategory.value
              // console.log('$vm.fileInfo[' + i + ']= ' + JSON.stringify($vm.fileInfo[i]))
              //$vm.$emit('update', $vm.fileInfo)
            }
            // console.log(dextCategory)
            // console.log('customHeaderObj.innerHTML', customHeaderObj.innerHTML)
          }
        }
      }

      this.$emit('completed', this.fileInfo)
      this.uploadingYn = 'N'
      // this.$emit('update', this.fileInfo)
      // console.log('update')
    },
    beforeFileDownload: function (uploadID, nWebFile, strItemKey, strItemOrgName, strItemUrlOrPath, largeFiles, isLastEvent) {
      if (this.isDebug) {
        console.log('beforeFileDownload  ' + uploadID)
      }
      return true
    },
    FinishDownloaded: function (uploadID, nDownloadItemCount) {
      if (this.isDebug) {
        console.log('FinishDownloaded  ' + uploadID, nDownloadItemCount)
      }
    },
    AfterAddItemEndTime: function (uploadID) {
      if (this.isDebug) {
        console.log('afteradditemendtime')
      }
      DEXT5UPLOAD.TransferEx(uploadID)
    },
    BeforeAddItem: function (uploadID, strFileName, nFileSize, nAddItemIndex, strFileLocalPath, objFile) {
      // console.log('this.single=', this.single)
      if (this.single) {
        let count = DEXT5UPLOAD.GetTotalFileCount(uploadID)
        // console.log('nAddItemIndex = ', nAddItemIndex)
        if (count > 1 || nAddItemIndex > 1) {
          let obj = {
            alertType: 'simple',
            customCloseBtnClass: 'button blue lg simplert-test1',
            customCloseBtnText: '확인',
            useIcon: false,
            customClass: 'simple_alert',
            message: '하나의 파일만 업로드해주세요',
            type: 'info'
          }
          alert('하나의 파일만 업로드해주세요')
          return false
        }
      }
    },
    BeforeDeleteItem: function (uploadID, strWebFile, strItemKey, strItemUrlOrPath, nDeleteItemIndex) {
      if (this.isDebug) {
        console.log('strItemKey = ' + strItemKey)
        console.log('nDeleteItemIndex = ' + nDeleteItemIndex)
      }
      for (let i = 0; i < this.fileInfo.length; i++) {
        if (i + 1 === nDeleteItemIndex) {
          this.fileInfo.splice(i, 1)
        }
      }
      // this.$emit('update', this.fileInfo)
    },
    UploadBegin: function () {
      if (this.isDebug) {
        console.log('UploadBegin')
      }
    },
    UploadCompleted: function () {
      if (this.isDebug) {
        console.log('UploadCompleted')
      }
    },
    getFileInfo: function () {
      return this.fileInfo
    },
    deleteAll: function () {
      if (this.isDebug) {
        console.log('close')
      }
      DEXT5UPLOAD.DeleteAllFile(this.options.id)
    },
    setFileInfo: function () {
      if (this.isDebug) {
        console.log('@@@@@@@@@@@@@ dext5upload setfileInfo')
      }
      let $vm = this
      if (this.makeDext) {
        if (this.isDebug) {
          console.log('DEXT5UPLOAD is defined')
        }

        // console.log('DEXT5UPLOAD = ', DEXT5UPLOAD)
        for (let i = 0; i < this.fileInfo.length; i++) {
          DEXT5UPLOAD.AddUploadedFile(this.index, this.fileInfo[i].originalName, '/', this.fileInfo[i].size, this.fileInfo[i].fileId, this.options.id)
          DEXT5UPLOAD.SetUploadedFile(this.index, this.fileInfo[i].guid, this.fileInfo[i].originalName, '/', this.fileInfo[i].size, this.fileInfo[i].fileId, this.options.id)
          this.index = this.index + 1
        }
        // console.log('onCreationComplete end')

        let fileListObj = DEXT5UPLOAD.GetUploadByName(this.options.id).frameWin.document.getElementById('file_list')

        if (fileListObj) {
          if (this.category) {
            // console.log('$vm.category= ' + $vm.category)
            // console.log('$vm.categoryInf= ' + JSON.stringify($vm.categoryInfo))
            let size = fileListObj.childNodes.length

            for (let i = 0; i < size; i++) {
              // console.log('@@@@@@@@ index = ', i)
              let customHeaderObj = fileListObj.childNodes[i].childNodes[0].childNodes[3].childNodes[0]
              customHeaderObj.style.textAlign = 'center'
              // customHeaderObj.innerHTML =
              let tempSelect = '<select style="height:15px;" id="' + this.fileInfo[i].guid + '">'

              // console.log('00000')
              // console.log('customHeaderObj.innerHTML = ' + tempSelect)
              if (this.fileInfo[i].category === '') {
                // console.log('미선택')
                tempSelect += '<option value="" selected>선택</option>'
              }
              for (let j = 0; j < this.categoryInfo.length; j++) {
                // console.log('iii= ', j)
                // console.log('$vm.categoryInfo[i] = ' + $vm.categoryInfo[j].value)
                // console.log('$vm.fileInfo[i].category = ' + $vm.fileInfo[i].category)
                //선택처리

                if (this.categoryInfo[j].value === this.fileInfo[i].category) {
                  tempSelect += '<option value="' + this.categoryInfo[j].value + '" selected>' + this.categoryInfo[j].category + '</option>'
                } else {
                  tempSelect += '<option value="' + this.categoryInfo[j].value + '" >' + this.categoryInfo[j].category + '</option>'
                }

                // console.log('customHeaderObj.innerHTML = ' + tempSelect)
              }

              tempSelect += '</select>'
              // console.log('444444= ', tempSelect)
              customHeaderObj.innerHTML = tempSelect
              let dextCategory = DEXT5UPLOAD.GetUploadByName(this.options.id).frameWin.document.getElementById($vm.fileInfo[i].guid)
              dextCategory.onchange = function selectChange (e) {
                // console.log('select = ', dextCategory.value)
                // console.log('$vm.fileInfo= ' + JSON.stringify($vm.fileInfo))
                $vm.fileInfo[i].category = dextCategory.value
                // console.log('$vm.fileInfo[' + i + ']= ' + JSON.stringify($vm.fileInfo[i]))
                // $vm.$emit('update', $vm.fileInfo)
              }
              // console.log(dextCategory)
              // console.log('customHeaderObj.innerHTML', customHeaderObj.innerHTML)
            }
          }
        }
      } else {
        if (this.isDebug) {
          console.log('DEXT5UPLOAD is undefined')
        }
      }
    },
    isUploading () {
      return this.uploadingYn === 'Y'
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
